import { render } from "./period-en.vue?vue&type=template&id=47c14378&scoped=true"
import script from "./period-en.vue?vue&type=script&lang=js"
export * from "./period-en.vue?vue&type=script&lang=js"

import "./period-en.vue?vue&type=style&index=0&id=47c14378&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47c14378"]])

export default __exports__